import { createApi } from "@reduxjs/toolkit/query/react";

import type { UserDTO } from "../../../../common/types/UserDTO";
import type { UserGroupDTO } from "../../../../common/types/UserGroupDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const userService = createApi({
  reducerPath: "userService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["User", "UserGroup"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getUser: builder.query<UserDTO, { id: number }>({
      query: ({ id }) => `/api/identity/users/${id}`,
      providesTags: (user) => [{ type: "User", id: user?.id }],
    }),
    getUsers: builder.query<UserDTO[], { accountId: string }>({
      query: ({ accountId }) => `/api/identity/users?account_id=${accountId}`,
      providesTags: [{ type: "User", id: "LIST" }],
    }),
    getUserGroups: builder.query<UserGroupDTO[], void>({
      query: () => `/api/identity/user-groups`,
      providesTags: [{ type: "UserGroup", id: "LIST" }],
    }),
  }),
});

export const { useGetUserQuery, useGetUsersQuery, useGetUserGroupsQuery } = userService;
